// Google Analytics GA4 Configuration and Utilities

// GA4 Measurement ID - Replace with your actual GA4 Measurement ID
export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      anonymize_ip: true,
      allow_google_signals: false,
      allow_ad_features: false
    });

    // Set default consent to 'denied' until user provides consent
    window.gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied'
    });
  }
};

// Check if user has consented to analytics
export const hasAnalyticsConsent = () => {
  if (typeof window === 'undefined') return false;

  try {
    const preferences = JSON.parse(localStorage.getItem('cookie-consent-preferences') || '{}');
    return preferences.analytics === true;
  } catch (e) {
    return false;
  }
};

// Check if user has consented to marketing
export const hasMarketingConsent = () => {
  if (typeof window === 'undefined') return false;

  try {
    const preferences = JSON.parse(localStorage.getItem('cookie-consent-preferences') || '{}');
    return preferences.marketing === true;
  } catch (e) {
    return false;
  }
};

// Page view tracking
export const pageview = (url) => {
  if (typeof window !== 'undefined' && window.gtag && hasAnalyticsConsent()) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

// Event tracking
export const event = ({ action, category, label, value }) => {
  if (typeof window !== 'undefined' && window.gtag && hasAnalyticsConsent()) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Custom event tracking for e-commerce
export const trackProductView = (product) => {
  if (typeof window !== 'undefined' && window.gtag && hasAnalyticsConsent()) {
    window.gtag('event', 'view_item', {
      currency: 'AUD',
      value: product.price,
      items: [{
        item_id: product.id,
        item_name: product.name,
        category: product.category,
        price: product.price,
        quantity: 1
      }]
    });
  }
};

export const trackAddToCart = (product, quantity = 1) => {
  if (typeof window !== 'undefined' && window.gtag && hasAnalyticsConsent()) {
    window.gtag('event', 'add_to_cart', {
      currency: 'AUD',
      value: product.price * quantity,
      items: [{
        item_id: product.id,
        item_name: product.name,
        category: product.category,
        price: product.price,
        quantity: quantity
      }]
    });
  }
};

export const trackPurchase = (orderDetails) => {
  if (typeof window !== 'undefined' && window.gtag && hasAnalyticsConsent()) {
    window.gtag('event', 'purchase', {
      transaction_id: orderDetails.id,
      currency: 'AUD',
      value: orderDetails.total,
      tax: orderDetails.tax,
      shipping: orderDetails.shipping,
      items: orderDetails.items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        category: item.category,
        price: item.price,
        quantity: item.quantity
      }))
    });
  }
};

// Update consent settings
export const updateConsent = (analyticsGranted, marketingGranted) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: analyticsGranted ? 'granted' : 'denied',
      ad_storage: marketingGranted ? 'granted' : 'denied'
    });
  }
};